import React from "react";

const BackgroundLogo: React.FC = () => {
  return (
    <div
      className="
        fixed inset-0 z-10 
        flex items-center justify-center 
        pointer-events-none 
        animate-logo-fade-in
      "
    >
      <img
        src="https://pupflkhgreielehxetyu.supabase.co/storage/v1/object/public/Public%20Asset/CarlineConsensor-PrimarySquare-Medium.png"
        alt="Carline Consensor"
        className="h-[30vh] w-auto max-h-[600px] object-contain"
      />
    </div>
  );
};

export default BackgroundLogo;

